// @flow
import React from 'react';
import { Form, Radio } from 'semantic-ui-react';
import { SbiGrid } from '@sbiteam/sbi-grid';

const columnDefinitions = [
    {
        checkboxSelection: true,
        headerCheckboxSelection: true,
        suppressFilter: true,
        maxWidth: 20
    },
    {
        field: 'email',
        headerName: 'Email',
        type: 'stringSetColumn'
    },
    {
        field: 'firstName',
        headerName: 'First Name',
        type: 'stringSetColumn'
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        type: 'stringSetColumn'
    },
    {
        field: 'isManager',
        headerName: 'Manager',
        type: 'booleanColumn',
        maxWidth: 85
    }
];

export default function PermissionsPane(props: {
    onChange: () => void,
    users: UserWithAnalyticsObject
}) {
    return (
        <SbiGrid
            columns={columnDefinitions}
            data={props.users}
            onGridReady={params => {
                params.api.forEachNode(node => {
                    node.setSelected(node.data.hasObject);
                });
                params.api.gridCore.gridOptions.onRowSelected = props.onChange;
            }}
            rowSelection="multiple"
        />
    );
}



// WEBPACK FOOTER //
// ./components/molecules/PermissionsPane.jsx